/**
 * Native share — thin wrapper around @capacitor/share.
 *
 * Web is untouched: every call site guards with IS_NATIVE_APP before
 * rendering a Share button at all (see Phase 4 brief — "no logos, no URL to
 * pricing", plain text only), so this file's `shareText` is only ever
 * called from native code paths, but it no-ops safely on web too in case
 * that guard is ever missed at a call site.
 */

import { Share } from '@capacitor/share'
import { IS_NATIVE_APP } from './runtime'

/**
 * Shares a plain-text summary via the OS share sheet (Messages, Mail,
 * copy, etc.) — no URL, no logo, nothing that reads as a marketing push.
 * @param {string} text - already-composed text, ending in "via JAI".
 * @returns {Promise<boolean>} true if the sheet opened (not whether the
 *   user actually completed a share — Capacitor doesn't reliably report
 *   that, and it isn't ours to know).
 */
export async function shareText(text) {
  if (!IS_NATIVE_APP) return false
  try {
    await Share.share({ text })
    return true
  } catch {
    // A user backing out of the share sheet also rejects this promise on
    // iOS — that's a cancel, not an error, so it's swallowed silently
    // rather than shown to the user.
    return false
  }
}
